import calculateRemainingTime from 'src/util/calculateRemainingTime';

const retrieveRemainingSessionTime = () => {
  const storedExpirationDate = localStorage.getItem('expirationTime');

  const remainingTime = calculateRemainingTime(storedExpirationDate);

  if (remainingTime <= 30000) {
    localStorage.removeItem('expirationTime');
    return null;
  }

  return remainingTime;
};

export default retrieveRemainingSessionTime;
